import { render, staticRenderFns } from "./addPrinterRuleFee.vue?vue&type=template&id=7750bef4"
import script from "./addPrinterRuleFee.vue?vue&type=script&lang=js"
export * from "./addPrinterRuleFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports